import React from 'react';
import './Spinner.css';

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner">
        <div className="pentagon"></div>
      </div>
    </div>
  );
};

export default Spinner;